















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Location from '@/services/Location';


@Component({
	components: {}
})
export default class LocationListFilterCity extends Vue {
	@Prop({}) city!: string;
	@Prop({}) locations!: Array<Location>;

	cityItems: Array<string> = [];

	populateCityItems() {
		if (this.cityItems.length === 0) {
			const cities = this.locations.map((location) => {
				return location.city;
			}).filter((a) => { return a; });
			this.cityItems = cities.filter((n, i) => {
				return cities.indexOf(n) === i;
			}).sort((a, b) => {
				return (a.toUpperCase() > b.toUpperCase()) ? 1 : -1;
			});
		}
	}

	clearCityItems() {
		this.cityItems = [];
	}

	get selected(): string {
		return this.city;
	}
	set selected(value: string) {
		this.$emit('updatecity', value);
	}
}
